import React from 'react';
import classnames from 'classnames';
import Tab, { Props as TabProps } from '../../Tab';
import s from './UnderlinedTab.scss';

export interface Props extends Omit<TabProps, 'viewClassNames'> {
  className?: string;
  size?: 'small' | 'medium' | 'big' | 'height-responsive';
}

/** A single, standalone tab matching the look of UnderlinedTabs.
 * You should probably not use this */
const UnderlinedTab: React.FC<Props> = ({ className, size, ...props }) => {
  return (
    <Tab
      {...props}
      viewClassNames={{
        tab: classnames(s['tab'], size && s[size], className),
        label: s['label'],
        prefix: s['prefix'],
        dropdown: s['dropdown'],
        'active-tab': s['active-tab'],
      }}
    />
  );
};
UnderlinedTab.displayName = 'UnderlinedTab';

export default UnderlinedTab;
